import $ from 'jquery';
import NewsService from '../service/NewsService';

let page = 1;

$('.news-more').click(function () {
    page += 1;

    const parameters = {};
    parameters.page = page;

    NewsService.getItems(parameters)
        .then((response) => {
            if (response.nextPage) {
                $('.news-more').removeClass('button--hidden');
            } else {
                $('.news-more').addClass('button--hidden');
            }
            NewsService.renderItems(response.items, true);
        });
});
